module.exports = {"640324100":"豫海镇","640324101":"河西镇","640324102":"韦州镇","640324103":"下马关镇","640324104":"预旺镇","640324105":"王团镇","640324106":"丁塘镇","640324201":"田老庄乡","640324202":"马高庄乡","640324203":"张家塬乡","640324204":"兴隆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640324.json
// module id = 3179
// module chunks = 0